export default __webpack_public_path__ + "static/media/product-app-2.e2a44c31.png";